import { render, staticRenderFns } from "./ResourceDataSchema.vue?vue&type=template&id=ab968054"
import script from "./ResourceDataSchema.vue?vue&type=script&lang=js"
export * from "./ResourceDataSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports